import { DocumentReference, DocumentData } from "@angular/fire/firestore";

export class MenuItemData {
  public categories: string[];
  public itemName: string;
  public itemPrice: number;
  public units: number;

  constructor(data: DocumentData) {
    this.categories = data.categories ?? [];
    this.itemName = data.itemName ?? "";
    this.itemPrice = data.itemPrice / 100;
    this.units = data.units;
  }
}
